import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from "react";
import { useActiveColorScheme } from "@m/alchemy-theme";
import { ScreenReaderContent } from "../../screen-reader-content/ScreenReaderContent";
import * as Styled from "./LoadingIndicator.styled";
export const LoadingIndicator = forwardRef((props, ref) => {
    /* istanbul ignore next */
    const { inverted = false, size = "large", label = "Loading", inline = false, palette = "expressiveInformative", ...otherProps } = props;
    const circleSize = size === "large" ? 8 : 5;
    const inlineSpreadProps = inline ? props : {};
    const activeColorScheme = useActiveColorScheme();
    const renderLoadingIndicator = (ref) => (_jsxs(Styled.Ellipsis, { ref: ref, "data-testid": "LoadingIndicatorEllipsis", activeColorScheme: activeColorScheme, inline: inline, inverted: inverted, palette: palette, circleSize: circleSize, speed: 1.86, ...inlineSpreadProps, children: [_jsx("span", {}), _jsx("span", {}), _jsx("span", {}), _jsx(ScreenReaderContent, { role: "status", children: label })] }));
    if (inline) {
        return renderLoadingIndicator(ref);
    }
    return (_jsx(Styled.LoadingIndicator, { ref: ref, "data-testid": "LoadingIndicator", ...otherProps, children: renderLoadingIndicator() }));
});
LoadingIndicator.displayName = "LoadingIndicator";
// This is temporary and can be removed/replaced by initializers once this issue is resolved:
// https://github.com/styleguidist/react-docgen-typescript/issues/254
LoadingIndicator.defaultProps = {
    inverted: false,
    size: "large",
    label: "Loading",
    inline: false,
    palette: "expressiveInformative"
};
